(function ($) {

    const initAjaxPaginationScroll = () => {
        const contentBlockSelector = '.ajax-pagination-scroll';
        const $contentBlock = $(contentBlockSelector);

        if (!$contentBlock.length) {
            return;
        }

        $(document).on('click', '.content-pagination a.page-numbers', function(e) {
            $('html, body').animate({
                scrollTop: $contentBlock.offset().top - 220
            }, 500);
        });
    };

    /**
     * Synchronizes the sidebar height with the map height.
     */
    function syncSidebarHeight() {
        const mapElement = document.getElementById('wpwc-yandex-map');
        const sidebarElement = document.getElementById('wpwc-affiliate-info-changeable');

        if (mapElement && sidebarElement) {
            function updateHeight() {
                const mapHeight = mapElement.offsetHeight;
                if (mapHeight > 0) {
                    sidebarElement.style.height = mapHeight + 'px';
                }
            }

            setTimeout(updateHeight, 100);

            let resizeTimeout;
            window.addEventListener('resize', function () {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(updateHeight, 100);
            });
        }
    }

    /**
     * Shows the affiliate info sidebar when an affiliate is selected.
     */
    function showAffiliateSidebar() {
        const sidebarElement = document.getElementById('wpwc-affiliate-info-changeable');

        if (!sidebarElement) {
            return;
        }

        setTimeout(function() {
            const nameElement = sidebarElement.querySelector('.affiliate-item .wpwc-affiliate-info__name');
            const hasContent = nameElement && nameElement.textContent.trim() !== '';

            if (hasContent) {
                sidebarElement.style.display = 'block';
                syncSidebarHeight();
            }
        }, 100);
    }

    /**
     * Video singles print the featured image for the player poster.
     * Pin that image over the content iframe and start playback on click.
     */
    const initVideoPoster = () => {
        const articles = document.querySelectorAll('.single-post.format-video.has-post-thumbnail');

        if (!articles.length) {
            return;
        }

        const pin = (article) => {
            const poster = article.querySelector(':scope > .post-media-wrapper');
            const iframe = article.querySelector('.post-content iframe');

            if (!poster || !iframe || poster.classList.contains('is-dismissed')) {
                return;
            }

            if (poster.querySelector('.wp-video, video')) {
                return;
            }

            const articleRect = article.getBoundingClientRect();
            const frameRect = iframe.getBoundingClientRect();

            poster.style.setProperty('--video-poster-x', (frameRect.left - articleRect.left) + 'px');
            poster.style.setProperty('--video-poster-y', (frameRect.top - articleRect.top) + 'px');
            poster.style.setProperty('--video-poster-w', frameRect.width + 'px');
            poster.style.setProperty('--video-poster-h', frameRect.height + 'px');
            poster.classList.add('is-poster');
        };

        articles.forEach((article) => {
            const poster = article.querySelector(':scope > .post-media-wrapper');
            const iframe = article.querySelector('.post-content iframe');

            if (!poster || !iframe || poster.querySelector('.wp-video, video')) {
                return;
            }

            poster.setAttribute('role', 'button');
            poster.setAttribute('tabindex', '0');
            poster.setAttribute('aria-label', 'Смотреть видео');

            const dismiss = () => {
                if (poster.classList.contains('is-dismissed')) {
                    return;
                }

                poster.classList.add('is-dismissed');

                try {
                    const url = new URL(iframe.src, window.location.href);
                    url.searchParams.set('autoplay', '1');
                    iframe.src = url.toString();
                } catch (error) {
                    // Leave the original embed src when it cannot be parsed.
                }
            };

            poster.addEventListener('click', dismiss);
            poster.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }

                event.preventDefault();
                dismiss();
            });

            pin(article);
        });

        window.addEventListener('resize', () => {
            articles.forEach(pin);
        });
    };

    $(document).ready(function() {
        initAjaxPaginationScroll();
        syncSidebarHeight();
        initVideoPoster();

        $(document).on('wpwc:affiliate-selected', function() {
            showAffiliateSidebar();
        });

        /**
         * Cookie Notice.
         */
        const cookieNotice = $('#cookieNotice');
        const cookieNoticeAccept = $('#cookieNoticeAccept');

        if (cookieNotice.length > 0) {
            const getCookie = (name) => {
                let matches = document.cookie.match(new RegExp(
                    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
                ));
                return matches ? decodeURIComponent(matches[1]) : undefined;
            };

            const setCookie = (name, value, days) => {
                let expires = "";
                if (days) {
                    let date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toUTCString();
                }
                document.cookie = name + "=" + (value || "") + expires + "; path=/; secure; samesite=lax";
            };

            if (!getCookie('techkorm_cookie_accepted')) {
                cookieNotice.show();
                setTimeout(() => {
                    cookieNotice.addClass('cookie-notice--visible');
                }, 100);
            }

            cookieNoticeAccept.on('click', () => {
                setCookie('techkorm_cookie_accepted', '1', 365);
                cookieNotice.removeClass('cookie-notice--visible');
                setTimeout(() => {
                    cookieNotice.hide();
                }, 400);
            });
        }

        initGalleryLightbox();
    });

    /**
     * Opens content gallery files in a dialog instead of a new page.
     */
    const initGalleryLightbox = () => {
        const $lightbox = $('.techkorm-gallery-lightbox');
        const $links = $('.content-wrapper .gallery .gallery-icon a[href], .content-wrapper .press-colors .wp-block-image a[href]');

        if (!$lightbox.length || !$links.length) {
            return;
        }

        const $image = $lightbox.find('.techkorm-gallery-lightbox__image');
        const $caption = $lightbox.find('.techkorm-gallery-lightbox__caption');
        const $nav = $lightbox.find('.techkorm-gallery-lightbox__nav');
        let $items = $();
        let index = 0;
        let lastFocused = null;

        const show = (nextIndex) => {
            const count = $items.length;

            if (!count) {
                return;
            }

            index = (nextIndex + count) % count;
            const $link = $items.eq(index);
            const caption = $.trim($link.closest('.gallery-item').find('.gallery-caption').text());

            $image.attr({
                src: $link.attr('href'),
                alt: $link.find('img').attr('alt') || ''
            });

            if (caption) {
                $caption.text(caption).removeAttr('hidden');
            } else {
                $caption.text('').attr('hidden', 'hidden');
            }

            if (count > 1) {
                $nav.removeAttr('hidden');
            } else {
                $nav.attr('hidden', 'hidden');
            }
        };

        const closeLightbox = () => {
            $lightbox.removeClass('techkorm-gallery-lightbox--open').attr('hidden', 'hidden').attr('aria-hidden', 'true');
            $image.attr('src', '');
            $('body').removeClass('techkorm-gallery-lightbox-active');

            if (lastFocused && typeof lastFocused.focus === 'function') {
                lastFocused.focus();
            }
        };

        const openLightbox = ($link) => {
            const $gallery = $link.closest('.gallery');

            $items = $gallery.length
                ? $gallery.find('.gallery-icon a[href]')
                : $link.closest('.press-colors').find('.wp-block-image a[href]');
            lastFocused = $link.get(0);
            show($items.index($link));
            $lightbox.removeAttr('hidden').attr('aria-hidden', 'false').addClass('techkorm-gallery-lightbox--open');
            $('body').addClass('techkorm-gallery-lightbox-active');
            $lightbox.find('.techkorm-gallery-lightbox__close').trigger('focus');
        };

        $links.on('click', function (event) {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.which === 2) {
                return;
            }

            const href = $(this).attr('href') || '';

            if (!/\.(jpe?g|png|gif|webp|avif)(\?|$)/i.test(href)) {
                return;
            }

            event.preventDefault();
            openLightbox($(this));
        });

        $lightbox.on('click', '[data-techkorm-gallery-close]', closeLightbox);

        $lightbox.on('click', '[data-techkorm-gallery-prev]', function (event) {
            event.preventDefault();
            event.stopPropagation();
            show(index - 1);
        });

        $lightbox.on('click', '[data-techkorm-gallery-next]', function (event) {
            event.preventDefault();
            event.stopPropagation();
            show(index + 1);
        });

        $lightbox.find('[role="button"]').on('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') {
                return;
            }

            event.preventDefault();
            $(this).trigger('click');
        });

        $(document).on('keydown.techkormGalleryLightbox', (event) => {
            if (!$lightbox.hasClass('techkorm-gallery-lightbox--open')) {
                return;
            }

            if (event.key === 'Escape') {
                closeLightbox();
            } else if (event.key === 'ArrowLeft') {
                show(index - 1);
            } else if (event.key === 'ArrowRight') {
                show(index + 1);
            }
        });
    };

})(jQuery);
